import { gql, useQuery, useMutation } from "@apollo/client";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Content } from "../../components/light/Content";
import { SectionBlock } from "../../components/light/SectionBlock";
import { Loading } from "../../components/Loading";
import { Toast } from "../../hooks/toast";
import { useTranslation } from "react-i18next";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "options", to: "#" },
  { text: "brands", to: "#" },
  { text: "l192 brand", to: "/options/brand/l192" },
];

const QUERY = gql`
  query merchantBrandAllList {
    merchantBrandAllList
  }
`;

const APPENDSUPPLY_BRAND = gql`
  mutation merchantAppendSupplyBrand($id: Int!) {
    merchantAppendSupplyBrand(id: $id)
  }
`;

export function L192BrandScreen() {
  const { t } = useTranslation();
  const { push } = useHistory();
  const [items, setItems] = useState<any[]>([]);
  const [index, setIndex] = useState(0);
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    onCompleted: (res) => {
      let data = res.merchantBrandAllList.reduce((r: any, e: any) => {
        let group = e.name[0].toUpperCase();
        if (!r[group]) r[group] = { group, children: [e] };
        else r[group].children.push(e);
        return r;
      }, {});

      let result: any = Object.values(data);
      setItems(result);
    },
  });
  const [merchantAppendSupplyBrand] = useMutation(APPENDSUPPLY_BRAND, {
    onCompleted: (res) => {
      if (res.merchantAppendSupplyBrand) {
        Toast.onShow(`Request supply brand in reviewing...`, "info", "right");
        push("/options/brand/list?filter=reviewing");
      }
    },
  });

  if (loading || data === undefined || items.length === 0) {
    return <Loading />;
  }

  // console.log(items);

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          <SectionBlock title={t('all_brand_in_l192')} transparent={true}>
            <div>
              {items.map((x, i) => (
                <button
                  className={`btn ${index === i ? "btn-primary" : "btn-outline-primary"
                    }`}
                  style={{
                    margin: '5px 5px 5px 0',
                  }}
                  onClick={() => setIndex(i)}
                >
                  {x.group}
                </button>
              ))}
            </div>
            <table className="table table-padded">
              <tbody>
                {items[index].children.map((x: any, i: number) => {
                  return (
                    <tr key={i}>
                      <td>
                        <b style={{ color: "#636c72" }}>{x.name}</b>
                      </td>
                      <td className="text-center">
                        <img src={x.banner} alt="" width={50} height={50} />
                      </td>
                      <td>
                        <small className="text-muted">{x.description}</small>
                      </td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            merchantAppendSupplyBrand({
                              variables: {
                                id: Number(x.id),
                              },
                            });
                          }}
                        >
                          {t('request_supply')}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}
